import { IAspectRatioHeightData } from "./height-data";
import { IWidgetVisibility, VisibilityData, WidgetFitMode, WidgetPlaceType } from "./index";
import { IPositionData } from "./position-data";
import { IAnimatedWidget } from "./widget-style-data";

export interface IVideoWidgetData extends IWidgetVisibility {
    readonly type: "VideoWidget";
    placeType: WidgetPlaceType;
    id?: string | null;
    videoType: VideoType;
    src: string;
    placeholder?: IVideoPlaceholder | null;
    embedType?: "youtube" | "vimeo" | null;
    autoplay: boolean;
    controls: boolean;
    loop: boolean;
    embedId?: string | null;
    aspectRatio?: number | null;
    style: IVideoWidgetStyle;
    videoName?: string | null;
}

export interface IVideoWidgetStyle extends IAnimatedWidget {
    heightData?: IAspectRatioHeightData | null;
    videoStyle?: IVideoStyle | null;
}

export interface IVideoStyle {
    fitMode?: WidgetFitMode | null;
}

export interface IVideoPlaceholder {
    thumbnailUrl: string | null;
    position: IPositionData | null
}

export type VideoType = "upload" | "embed";

export abstract class VideoWidgetData {

    public static get defaultData(): IVideoWidgetData {
        return {
            src: "",
            type: "VideoWidget",
            placeType: "Section",
            videoType: "embed",
            placeholder: null,
            embedType: null,
            autoplay: false,
            controls: true,
            loop: false,
            style: this.defaultStyle,
            visibility: VisibilityData.defaultData(),
            videoName: null
        };
    }

    public static get defaultStyle(): IVideoWidgetStyle {
        return {
            animation: {
                animationSource: "site-design",
                animationData: {
                    name: "none",
                    duration: 1
                }
            },
            heightData: {
                paddingTop: 56.25
            },
            videoStyle: {
                fitMode: "cover"
            }
        };
    }

}
